var React = require('react');

function TextCursor (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M17 22h-1a4 4 0 0 1-4-4V6a4 4 0 0 1 4-4h1","key":0}),React.createElement("path",{"d":"M7 22h1a4 4 0 0 0 4-4v-1","key":1}),React.createElement("path",{"d":"M7 2h1a4 4 0 0 1 4 4v1","key":2})]);
}

TextCursor.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"lucide lucide-text-cursor-icon lucide-text-cursor"};

module.exports = TextCursor;

TextCursor.default = TextCursor;
